import { Divider } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { observer } from 'mobx-react-lite';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import React, { useContext, useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import WindsorApi from '../../../api/WindsorApi';
import LinkRouter from '../../../common/LinkRouter';
import LoadingIndicator from '../../../common/LoadingIndicator';
import { removeEmptyFields } from '../../../common/WorkflowUtils';
import MobxContext from '../../../mobx/MobxContext';
import WorkflowForm from './WorkflowForm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1200,
      margin: 'auto'
    },
    divider: {
      marginBottom: 16,
      marginTop: 8
    }
  })
);

const windsorApi = new WindsorApi();

function WorkflowEditPage(props: RouteComponentProps<any> & WithSnackbarProps) {
  const { match, history, enqueueSnackbar } = props;
  const familyId = match.params.familyId;
  const workflowId = match.params.workflowId;

  const classes = useStyles({});
  const [workflow, setWorkflow] = useState(null);
  const [originalWorkflow, setOriginalWorkflow] = useState(null);
  const [family, setFamily] = useState(null);
  const [tests, setTests] = useState(null);
  const { cspGroupStore, environmentStore } = useContext(MobxContext);

  useEffect(() => {
    Promise.all([
      windsorApi.getWorkflow(familyId, workflowId),
      windsorApi.getFamily(familyId),
      windsorApi.getTests(familyId)
    ]).then(([workflow, family, tests]) => {
      setWorkflow(workflow);
      setOriginalWorkflow(workflow);
      setFamily(family);
      setTests(tests);
    });
  }, [familyId, workflowId]);

  const onWorkflowChange = (workflow: any) => {
    setWorkflow(workflow);
  };

  const onSave = () => {
    const workflowToEdit = { ...workflow, Family: familyId, GUID: workflowId };

    removeEmptyFields(workflowToEdit);
    return windsorApi.updateWorkflow(workflowToEdit);
  };

  const onSaveComplete = () => {
    enqueueSnackbar('Workflow updated');
    history.push(`/families/${familyId}/workflows/${workflowId}`);
  };

  const onCancel = () => {
    history.push(`/families/${familyId}/workflows/${workflowId}`);
  };

  if (workflow && originalWorkflow && family && tests && cspGroupStore.groups && environmentStore.environments) {
    return (
      <div className={classes.root}>
        <Breadcrumbs aria-label="breadcrumb">
          <LinkRouter color="textSecondary" to={`/families`}>
            Families
          </LinkRouter>
          <LinkRouter color="textSecondary" to={`/families/${family.GUID}`}>
            {family.Name}
          </LinkRouter>
          <LinkRouter color="textSecondary" to={`/families/${family.GUID}`}>
            Workflows
          </LinkRouter>
          <LinkRouter color="textSecondary" to={`/families/${family.GUID}/workflows/${originalWorkflow.GUID}`}>
            {originalWorkflow.Name}
          </LinkRouter>
          <Typography color="textPrimary">Edit</Typography>
        </Breadcrumbs>
        <Divider className={classes.divider} />
        <WorkflowForm
          title="Edit Workflow"
          workflow={workflow}
          family={family}
          tests={tests}
          cspGroups={cspGroupStore.groups}
          environments={environmentStore.environments}
          onWorkflowChange={onWorkflowChange}
          onSave={onSave}
          onSaveComplete={onSaveComplete}
          onCancel={onCancel}
        />
      </div >
    );
  } else {
    return <LoadingIndicator loading={true} />;
  }
};

export default withRouter(withSnackbar(observer(WorkflowEditPage)));
